import React, { createContext, useContext, useReducer } from "react";
export const ResourceContext = createContext();
export const ResourceProvider = ({ reducer, initialState, children }) => /* @__PURE__ */ React.createElement(ResourceContext.Provider, { value: useReducer(reducer, initialState) }, children);
export const useResourceState = () => useContext(ResourceContext);
